import { FC } from 'react';
import { Navigate } from 'react-router-dom';

export const NavigateTo404: FC<{}> = () => {
  return <Navigate to="/404" replace={true} />;
};

export default NavigateTo404;
